import { render, staticRenderFns } from "./OldAddQualifications.vue?vue&type=template&id=99d0db2e"
import script from "./OldAddQualifications.vue?vue&type=script&lang=js"
export * from "./OldAddQualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports